import queryString from "query-string";

export default function getParamsFromHash()
{
	return queryString.parse(window.location.hash);
}